module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.hideIndexChrome) ? _c('div', {
    staticClass: "others_header il-bc-chrome"
  }, [_c('nav', {
    staticClass: "bc-top-nav bc-top-nav--in"
  }, [_c('div', {
    staticClass: "bc-top-nav__inner"
  }, [_c('div', {
    staticClass: "bc-lang"
  }, [_c('button', {
    staticClass: "bc-lang__btn",
    class: {
      'bc-lang__btn--active': _vm.$getLocale() === 'en-US'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.layoutSetLangEn
    }
  }, [_vm._v("\n            EN\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "bc-lang__btn",
    class: {
      'bc-lang__btn--active': _vm.$getLocale() === 'zh-CN'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.layoutSetLangZh
    }
  }, [_vm._v("\n            CN\n          ")])]), _vm._v(" "), (_vm.$route.path === '/sai-data-list') ? _c('button', {
    staticClass: "bc-apply-records-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.layoutGoApplyList
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$T('我的报名记录')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "bc-menu-trigger",
    attrs: {
      "type": "button",
      "aria-label": "menu"
    },
    on: {
      "click": function($event) {
        _vm.layoutMenuOpen = true
      }
    }
  }, [_c('svg', {
    staticClass: "bc-menu-trigger__icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 6h16M4 12h16M4 18h16",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "bc-hero bc-hero--inner"
  }, [_c('div', {
    staticClass: "bc-hero__bg"
  }, [_c('img', {
    staticClass: "bc-hero__bg-img",
    attrs: {
      "src": _vm.slideMenuBg,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bc-hero__logo bc-hero__logo--in"
  }, [_c('button', {
    staticClass: "bc-hero__logo-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.layoutGoHome
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.footerLogoUrl,
      "alt": "Trampoline Gymnastics World Championships Nanjing 2026"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), (!_vm.hideIndexChrome) ? _c('BcSlideMenu', {
    attrs: {
      "visible": _vm.layoutMenuOpen,
      "bg-image": _vm.slideMenuBg,
      "items": _vm.slideMenuItems,
      "label-mode": "i18n"
    },
    on: {
      "update:visible": function($event) {
        _vm.layoutMenuOpen = $event
      },
      "select": _vm.onLayoutSlideMenuSelect
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.name != 'Login' && !_vm.hideIndexChrome) ? _c('footer', {
    staticClass: "bc-footer"
  }, [_c('div', {
    staticClass: "bc-footer__deco",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    staticClass: "bc-footer__wave",
    attrs: {
      "viewBox": "0 0 1440 320",
      "preserveAspectRatio": "none"
    }
  }, [_c('path', {
    attrs: {
      "fill": "rgba(43,123,191,0.3)",
      "d": "M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bc-footer__circle bc-footer__circle--1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bc-footer__circle bc-footer__circle--2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bc-footer__circle bc-footer__circle--3"
  }), _vm._v(" "), _c('div', {
    staticClass: "bc-footer__bars"
  }, _vm._l((12), function(i) {
    return _c('div', {
      key: 'fb-' + i,
      staticClass: "bc-footer__bar",
      style: ({
        height: ((i - 1) % 3 + 1) * 20 + 'px'
      })
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "bc-inner bc-footer__main"
  }, [_c('div', {
    staticClass: "bc-footer__left"
  }, [_c('img', {
    staticClass: "bc-footer__logo",
    attrs: {
      "src": _vm.footerLogoUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bc-footer__copy"
  }, [_vm._v("© 2026 Trampoline World Championships Nanjing")]), _vm._v(" "), _c('p', {
    staticClass: "bc-footer__sub"
  }, [_vm._v("Hosted in Nanjing Jiangbei New Area | November 5-8, 2026")])]), _vm._v(" "), _c('div', {
    staticClass: "bc-footer__right"
  }, [_c('h3', [_vm._v("Stay tuned!")]), _vm._v(" "), _c('div', {
    staticClass: "bc-footer__social"
  }, [_c('a', {
    staticClass: "bc-footer__soc",
    attrs: {
      "href": "#",
      "aria-label": "Facebook"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.footerComingSoon($event)
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "currentColor",
      "width": "24",
      "height": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "bc-footer__soc",
    attrs: {
      "href": "#",
      "aria-label": "Instagram"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.footerComingSoon($event)
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "currentColor",
      "width": "24",
      "height": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "bc-footer__soc",
    attrs: {
      "href": "#",
      "aria-label": "YouTube"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.footerComingSoon($event)
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "currentColor",
      "width": "24",
      "height": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "bc-footer__soc",
    attrs: {
      "href": "#",
      "aria-label": "X"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.footerComingSoon($event)
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "currentColor",
      "width": "24",
      "height": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bc-inner bc-footer__links"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.footerComingSoon
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.footerComingSoon
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.footerComingSoon
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.footerComingSoon
    }
  }, [_vm._v("Media")])])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.centerDialogVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("正在建设中~")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "公众号二维码",
      "visible": _vm.wechatDialogVisible,
      "width": "300px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.wechatDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "tc"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require('../../assets/images/contact/cca-2.png'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2941f75c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/IndexLayout.vue
// module id = 1350
// module chunks = 0